import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  Home,
  MapPin,
  Upload,
  ListMusic,
  CalendarDays,
  Gamepad2,
  LogOut
} from "lucide-react";
import logo from "../../assets/logo.png";

export default function Sidebar({ isOpen, onClose }) {
  const location = useLocation();
  const navigate = useNavigate();

  const menuItems = [
    { name: "Dashboard", path: "/dashboard", icon: <Home size={18} /> },
    // { name: "Outlets", path: "/outlets", icon: <MapPin size={18} /> },
    { name: "Status", path: "/Status", icon: <Gamepad2 size={18} /> },
    { name: "Media Upload", path: "/media", icon: <Upload size={18} /> },
    { name: "Playlists", path: "/playlist", icon: <ListMusic size={18} /> },
    { name: "Schedule", path: "/schedule", icon: <CalendarDays size={18} /> },
    { name: "Stream", path: "/admin/stream", icon: <Gamepad2 size={18} /> },
  ];

  const handleLogout = () => {
    localStorage.removeItem("token");  // remove auth token
    navigate("/");                     // redirect to login page
  };

  return (
    <>
      {/* Overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/40 backdrop-blur-sm z-40"
          onClick={onClose}
        ></div>
      )}

      {/* Sidebar Drawer */}
      <div
        className={`fixed top-0 left-0 h-full w-72 bg-white shadow-2xl z-50 px-6 py-5
          transform transition-transform duration-300 ease-in-out
          flex flex-col justify-between border-r
          ${isOpen ? "translate-x-0" : "-translate-x-full"}
        `}
      >

        {/* TOP SECTION */}
        <div>
          <div className="flex items-center gap-3 mb-8">
            <img src={logo} className="h-10 w-10" alt="logo" />
            <h2 className="text-2xl font-extrabold text-blue-700 tracking-tight">
              Music Admin
            </h2>
          </div>

          <ul className="space-y-1 text-gray-700 font-medium">
            {menuItems.map((item) => {
              const active = location.pathname === item.path;

              return (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    onClick={onClose}
                    className={`flex items-center gap-3 p-3 rounded-lg transition-all
                      ${active
                        ? "bg-blue-600 text-white shadow-md"
                        : "hover:bg-blue-50"
                      }
                    `}
                  >
                    <span className={`${active ? "text-white" : "text-blue-600"}`}>
                      {item.icon}
                    </span>
                    <span>{item.name}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>

        {/* BOTTOM SECTION */}
        <div className="space-y-4">

          {/* LOGOUT BUTTON */}
          <button
            onClick={handleLogout}
            className="w-full flex items-center justify-center gap-2 p-3 text-red-600 
            border border-red-300 rounded-lg hover:bg-red-50 transition-all"
          >
            <LogOut size={18} />
            <span className="font-semibold">Logout</span>
          </button>

          {/* POWERED BY */}
          <div className="text-center text-gray-500 text-sm pt-4 border-t">
            <img
              src={logo}
              alt="Synoweb Logo"
              className="h-12 w-auto mx-auto mb-1 opacity-90"
            />
            <p>
              © Powered by <br />
              <span className="font-semibold text-blue-700">
                Synoweb Technology 2025
              </span>
            </p>
          </div>
        </div>

      </div>
    </>
  );
}
